export enum ConditionsConjuntion {
  AND = 'AND',
  OR = 'OR',
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/enums/conditions-conjuntion.enum.ts